import { useEffect, useContext } from 'react';
import PageContext from '@/Providers/PageContextProvider/PageContext';
import { getPlatformTheme, subscribePreferences } from '@/shared/platform/preferences';
export const getThemeBySystemConfiguration = getPlatformTheme;
export default function useTheme() {
  const { isPreview, experienceSettings, setTheme } = useContext(PageContext);
  useEffect(() => {
    if (!experienceSettings?.color.isDarkModeEnabled || isPreview) return;
    const update = () => setTheme(getPlatformTheme());
    update(); return subscribePreferences(update);
  }, [experienceSettings, isPreview, setTheme]);
}
